var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box main",style:(_vm.style)},[_c('div',{staticClass:"error"},[_c('span',{staticClass:"error-con"},[_vm._v("哎呀，你访问的页面不存在！")]),_c('span',[_vm._v("你输入的网址有误或链接已经过期。 ")]),_c('span',{staticClass:"error-home"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.goBack()}}},[_vm._v("返回登录")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }